export class AuditLog {
    auditLogId: number;
    logDescription: string;
    logDate: string;
    logTypeId: number;
    logFrom:number;  
    logTypeName:string;
    AccountId:number;
    fullName:string;
    roleName:string;
    totalItems: number;
    roleId: number;
    locationId: number;

}
